import { HttpClient } from '@angular/common/http';
import { Component, OnInit, Renderer2 } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TokenService } from '@services/auth/token.service';
import { TitleService } from '@services/title.service';
import { SharedService } from './../../../services/shared/shared.service';
import { commonDtOptions, theads } from './table.definition';
import { environment } from 'environments/environment';

class DataTablesResponse {
  data: any[];
}
@Component({
  selector: 'app-salvage',
  templateUrl: './salvage.component.html',
  styleUrls: ['./salvage.component.scss'],
})
export class SalvageComponent implements OnInit {
  public dtOptions: any = {};
  public filterOptions: object = {};
  public theads = theads;
  public tableData: object[] = [];
  public isFilterMode: boolean = false;
  public noFilterMode: boolean = true;
  public activeTab: 'available' | 'sold' = 'available';
  public makes: object = {};
  public models: object = {};
  public trimType: object = {};
  public modelYears: object = {};
  public exteriorColor: object = {};
  public isLoading = false;

  public eventListener: () => void;

  constructor(
    private sharedService: SharedService,
    public router: Router,
    public activatedRoute: ActivatedRoute,
    private http: HttpClient,
    private tokenService: TokenService,
    private renderer: Renderer2,
    private titleService: TitleService
  ) {
    this.dtOptions = this.getDtOptions();
  }

  ngOnInit(): void {
    this.titleService.updateTitle('Retail Inventory');

    this.activeTab = this.activatedRoute.snapshot.queryParamMap.get('type') as
      | 'available'
      | 'sold';
  }

  searchProductsFromList(event: Event) {
    let debounceTime = 500;
    this.isLoading = true;

    this.isFilterMode = false;
    this.noFilterMode = false;
    const selectedKey = (event.target as HTMLInputElement).name;
    const value = (event.target as HTMLInputElement).value;

    this.filterOptions = { ...this.filterOptions, [selectedKey]: value };

    // if (selectedKey === 'active') {
    //   this.filterOptions = { ...this.filterOptions, 'Body Type': '' };
    // } else {
    //
    // }

    if (selectedKey === 'VIN Number' || selectedKey === 'Plate Number') {
      debounceTime = 2000;
    }

    setTimeout(() => {
      this.isFilterMode = true;
      this.isLoading = false;
    }, debounceTime);
  }

  resetFilter() {
    this.isLoading = true;
    this.noFilterMode = true;
    this.isFilterMode = false;
    this.filterOptions = {};

    document.getElementById('make')['value'] = '';
    document.getElementById('model')['value'] = '';
    document.getElementById('trim-type')['value'] = '';
    document.getElementById('model-year')['value'] = '';
    document.getElementById('exterior-color')['value'] = '';
    document.getElementById('active-inactive-status')['value'] = '';
    document.getElementById('vin-number')['value'] = '';
    document.getElementById('registration-number')['value'] = '';

    setTimeout(() => {
      this.isLoading = false;
    }, 500);
  }

  tabSwitch(tabName: 'available' | 'sold') {
    this.activeTab = tabName;
    this.noFilterMode = true;
    this.isFilterMode = false;

    this.router.navigate([], {
      queryParams: { type: this.activeTab },
      queryParamsHandling: 'merge',
    });
  }

  viewProduct(productId: string) {
    this.router.navigate([`/dashboard/inventory/vehicle-details/${productId}`]);
  }

  ngAfterViewInit(): void {
    this.eventListener = this.renderer.listen('document', 'click', (event) => {
      if (event.target && event.target.closest('.view-btn')) {
        const productId = event.target
          .closest('.view-btn')
          .getAttribute('data-product-id');
        this.viewProduct(productId);
      }
    });
  }

  ngAfterViewChecked() {
    // This is for to fix the style for show entries
    const parentElement = document.getElementById('retail-vehicles_length');

    if (parentElement) {
      const labelElement = parentElement.querySelector('label');

      if (labelElement) {
        Object.assign(labelElement.style, {
          display: 'flex',
          alignItems: 'center',
          gap: '4px',
        });

        const selectElement = labelElement.querySelector('select');

        if (selectElement) {
          selectElement.style.width = '5rem';
        }
      }
    }
  }

  ngOnDestroy(): void {
    // To remove event listner
    this.eventListener();
  }

  getDtOptions() {
    return {
      ...commonDtOptions,

      ajax: (dataTablesParameters: any, callback) => {
        const baseParams = {
          type: 'product',
          limit: dataTablesParameters.length,
          page: dataTablesParameters.start / dataTablesParameters.length + 1,
          ...this.filterOptions,
        };

        const url = `${environment.v5}salvage/product/list`;

        this.http
          .get<DataTablesResponse>(url, {
            headers: this.tokenService.getTokenHeader(),
            params: baseParams,
          })
          .subscribe((resp) => {
            this.tableData = this.sharedService.prepareSalvageTableData(
              resp.data,
              'used'
            );

            callback({
              recordsTotal: resp?.data?.[0]?.['total_rows'] || 0,
              recordsFiltered: resp?.data?.[0]?.['total_rows'] || 0,
              data: this.tableData,
            });

            if (resp['success']) {
              const filterUrl = `${environment.v5}salvage/product/filter`;
              // const filterUrl = `http://192.168.0.155:3000/stage/salvage/product/filter`;

              return this.http
                .get(filterUrl, {
                  params: { type: 'product', ...this.filterOptions },
                })
                .subscribe((res) => {
                  this.makes = res?.['data']?.[0]?.['Make'];
                  this.models = res?.['data']?.[1]?.['Model'];
                  this.modelYears = res?.['data']?.[2]?.['Model Year'];
                  this.trimType = res?.['data']?.[3]?.['Trim/Type'];
                  this.exteriorColor = res?.['data']?.[4]?.['Exterior Colour'];
                });
            }
          });
      },
    };
  }
}
